<template>
<div>
    
    <Row type="flex" justify="center" align="top" class="code-row-bg" :gutter="0">
        <Col v-for="(item) in Items" :xs="{ span:24, offset:0 }" :sm="8" :md="8" :lg="6" style="padding:5px">

        <!--<Col v-for="(item) in Items" :xs="{ span:12, offset:0 }" style="padding:5px">-->
        
            <SingleProduct :Item="item" />
        </Col>
    </Row>
</div>
</template>



<script>
import SingleProduct from './SingleProduct.vue'

export default {
	name: 'ProductListing', 
	components: { SingleProduct },
	props: {
		Items: Array
    },
    methods: {
    }	
    
}
</script>


